<div class="overlay-container" style="display:{display};" bind:this={me}>
  <div 
    class="overlay { css && css.classes(vw) }"
    style={ css && css.styled(vw) } 
    on:click|self={ ()=>{ show = !modal ? false : show ; }}
    transition:fade="{{delay: 20, duration: 300}}"
    >
  </div>
  {#if show}
    <div 
      class="content { centered ? ' centered': '' }"
      style={bounded}>
      <slot></slot>
    </div> 
  {/if}
</div>

<style>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom:0;
  box-sizing: border-box;
  padding: 0;
  margin:0;
  z-index: 3;
  overflow: hidden;
  background-color: #eee;
  opacity: 0.55;
  /* debug */
  --border: 1px dotted red;
}

.overlay.transparent {
  background-color: transparent !important;
  opacity: 0 !important;
}

.content {
  background-color: transparent;
  position: fixed;
  box-sizing: border-box;
  padding: 0;
  margin:0;
  z-index: 4;
  overflow: hidden;
}

.centered {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>

<svelte:window bind:innerWidth={vw} />

<script>
  import { onMount, onDestroy } from 'svelte'
  import { fade, slide } from "svelte/transition";
  import { quintInOut } from 'svelte/easing';
  import { Css } from '../theme';
    
  export let 
    show = false,
    modal = false,
    centered = false,
    bounded;

  let 
    me, portal, display = 'none',
    vw = 0,
    css = Css($$props);
    
  $: if (vw && $$props) {
    show = css.visible(show, vw);
  }

  $: {
    display = !!show ? 'block' : 'none'
    console.log("Overlay show=", show, " display=", display);
  } 

  onMount(() => {
    portal = document.createElement('div')
    portal.className = 'overlay-portal'
    document.body.appendChild(portal)
    portal.appendChild(me)
  })
  
  onDestroy(() => {
    document.body.removeChild(portal)
  })

</script>
